import { MY_CARS_KEY, TOPIC_KEY } from '../global-constants';

export const getLocalStorage = () => {
	try {
		const item = window.localStorage.getItem(MY_CARS_KEY);
		return item ? JSON.parse(item) : null;
	} catch (error) {
		return null;
	}
};

export const setLocalStorage = (newStateValue) => {
	try {
		if (newStateValue) {
			window.localStorage.setItem(
				MY_CARS_KEY,
				JSON.stringify(newStateValue)
			);
			// Publish the event to the mycars-user-update topic
			window.DDC.pubsub.publish(TOPIC_KEY);
		}
	} catch (error) {
		// TODO: add a NR attribute
	}
};
